




import Vue from 'vue';

export default Vue.extend({
  auth: true,
  layout: 'layout-exterior',
  computed: {
    isAdmin(): boolean {
      let isAdmin = false;
      if (this.$auth.isLoggedIn) {
        isAdmin = this.$auth.isInRole('Admin', 'HostAdmin');
      }
      return isAdmin;
    },
  },
  beforeMount() {
    if (this.isAdmin) {
      this.$router.push('/projects');
    } else {
      this.$router.push('/Glit/CustomerProjectSuite');
    }
  },
});
